import { SECTION_URL } from "../../helpers/api.routes";
import { requests } from "../../helpers/api.services";

export const SectionService = {
  getAll: (params: any) => requests.get(`${SECTION_URL}`, params),
  create: (params: any) => requests.post(`${SECTION_URL}`, params),
  getSingle: (id: number) => requests.get(`${SECTION_URL}/${id}`),
  update: (params: any, id: number) => requests.put(`${SECTION_URL}/${id}`, params),
  delete: (id: number) => requests.delete(`${SECTION_URL}/${id}`),
};